import script from "./search-auto-complete-alg.vue?vue&type=script&lang=jsx&setup=true"
export * from "./search-auto-complete-alg.vue?vue&type=script&lang=jsx&setup=true"

import "./search-auto-complete-alg.vue?vue&type=style&index=0&id=01d68411&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d68411"]])

export default __exports__